import { render, staticRenderFns } from "./SuperResolutionImage.vue?vue&type=template&id=83644212&scoped=true&"
import script from "./SuperResolutionImage.vue?vue&type=script&lang=js&"
export * from "./SuperResolutionImage.vue?vue&type=script&lang=js&"
import style0 from "./SuperResolutionImage.vue?vue&type=style&index=0&id=83644212&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83644212",
  null
  
)

export default component.exports